var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPublicApiIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-public-api"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "public-api",
    clipPath: "url(#clip-public-api)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_27575",
    "data-name": "Group 27575",
    transform: "translate(14882 12351.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_33183",
    "data-name": "Rectangle 33183",
    transform: "translate(-14882 -12348)",
    fill: "none",
    stroke: "#616c7b",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 23,
    rx: 5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 0.75,
    width: 28.5,
    height: 21.5,
    rx: 4.25,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_37271",
    "data-name": "Path 37271",
    d: "M6.1-.526H8.134l-2.857-7.9H3.05L.192-.526H2.206l.473-1.395H5.626Zm-.968-2.88H3.185L4.152-6.3Zm6.131-1.485v-1.98h1.046c.765,0,1.091.383,1.091.99s-.326.99-1.091.99Zm4.1-.99c0-1.451-.967-2.542-2.9-2.542H9.338v7.9h1.924V-3.362h1.193C14.468-3.362,15.357-4.576,15.357-5.882ZM16.7-.526h1.924v-7.9H16.7Z",
    transform: "translate(-14876.405 -12332.274)",
    fill: "#687083"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPublicApiIcon);
export default __webpack_public_path__ + "static/media/public_api_icon.ab8ce66b51b10fc113ada94188d8603d.svg";
export { ForwardRef as ReactComponent };